import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from './Card';
import {
  setContractStatusStyle,
  useContractStatusStyle,
  type ContractStatusStyle,
} from '../hooks/useContractStatusStyle';

const OPTIONS: ContractStatusStyle[] = ['count', 'stack'];

/** The profile page's choice of how the status badge shows the other contracts. */
export function ContractStatusStyleSetting({ className = 'mb-4' }: { className?: string }) {
  const { t } = useTranslation();
  const style = useContractStatusStyle();
  return (
    <Card title={t('contractStatusStyle.title')} className={className}>
      <fieldset data-testid="contract-status-style">
        <legend className="form-label fs-6 fw-semibold mb-1">{t('contractStatusStyle.label')}</legend>
        <p className="text-muted small mb-1">{t('contractStatusStyle.help')}</p>
        {OPTIONS.map(option => (
          <label key={option} className="contract-status-style-option">
            <input
              type="radio"
              className="form-check-input"
              name="contract-status-style"
              value={option}
              checked={style === option}
              onChange={() => setContractStatusStyle(option)}
            />
            <span>
              <span className="d-block fw-semibold">{t(`contractStatusStyle.${option}`)}</span>
              <span className="d-block text-muted small">{t(`contractStatusStyle.${option}Help`)}</span>
            </span>
          </label>
        ))}
      </fieldset>
    </Card>
  );
}
